// plugins/api.ts
import { useAuthStore } from '~/store/auth'

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()
  const authStore = useAuthStore()
  authStore.loadUserFromStorage()

  let headers = {
    // 'Accept': 'application/json',
    // 'X-Requested-With': 'XMLHttpRequest',
  }

  let ApiToken = null;

    ApiToken = useCookie('api_token');

  
  if (ApiToken.value) {
    headers = {
      ...headers,
      Authorization: `Bearer ${ApiToken.value}`,
    }
  }

  const api = $fetch.create({
    baseURL: config.public.apiBase,
    headers,
    onResponseError: (error) => {
      if (error.response?.status === 419 || error.response?.status === 401) {
        authStore.logout()
      }
      return Promise.reject(error)
    },
  })

  return {
    provide: {
      api,
    },
  }
})
